export interface Chat {
    avatar: string
    chatId: number
    email?: string
    lastMessage: LastMessage | null
    name: string
    unreadCount: number
    userId: string
}

export interface ChatTokenResponse {
    token: string
}

export interface LastMessage {
    id?: number
    userId: string
    timestamp: string
    viewed: boolean
}

export interface Message {
    id?: number
    text: string
    externalUserId: string
    timestamp: string
    hash?: string
    chatId: number
    status: MessageStatus
    viewed?: boolean
}

export enum WebsocketActions {
    CREATED = "created",
    NEW = "new",
    VIEWED = "viewed",
}

export enum MessageStatus {
    CREATED = "created",
    SENT = "sent",
    VIEWED = "viewed",
}

export interface WebsocketChatMessage {
    action?: string
    hash?: string
    id?: number
    timestamp?: string
    chatId?: number
    text?: string
    externalUserId?: string
}
